import { createFileRoute, Outlet } from '@tanstack/react-router';
import { StaffShell } from '../../../../components/shell/staff-shell';
import { requireStaff, requireTwoFactorSetup } from '../../../../lib/guards';

// The signed-in staff app (admin, account manager, lead specialist, specialist) in the rail shell.
export const Route = createFileRoute('/subdomain/admin/_staff')({
  beforeLoad: async ({ context, location }) => {
    const session = await requireStaff(context.queryClient);
    await requireTwoFactorSetup(context.queryClient, location.pathname);
    return session;
  },
  component: () => (
    <StaffShell>
      <Outlet />
    </StaffShell>
  ),
});
